module.exports = __webpack_public_path__ + "static/media/camp.f59012cc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/camp.JPG
// module id = 480
// module chunks = 0